import $ from "jquery";
// CSS
require("../sass/core.sass");

// page CSS that was previously in templates
// leaving this here so it's easy to find
require("../sass/pages/about.sass");
require("../sass/pages/about-nounji.sass");
require("../sass/pages/allauth.sass");
require("../sass/pages/app-about.sass");
require("../sass/pages/app-confirm-upgrade.sass");
require("../sass/pages/app-connect.sass");
require("../sass/pages/app-download.sass");
require("../sass/admin.sass");
require("../sass/pages/admin.sass");
require("../sass/pages/billing.sass");
require("../sass/pages/creators.sass");
require("../sass/pages/developers.sass");
require("../sass/pages/facebook-connect-option.sass");
require("../sass/pages/flat-page.sass");
require("../sass/pages/forgot-password.sass");
require("../sass/pages/handbook.sass");
require("../sass/pages/logout.sass");
require("../sass/pages/royalties.sass");
require("../sass/pages/settings.sass");
require("../sass/pages/suspended-user-view.sass");
require("../sass/pages/team.sass");
require("../sass/pages/teams.sass");
require("../sass/pages/topsites-preview.sass");
require("../sass/pages/upload.sass");

var React = require("react");
var ReactDOM = require("react-dom");
import store from "./stores/reduxStore";

// Sometimes /js18n/ doesn't load in time for some reason
// Many components use gettext in their render methods so
// stub it out just it case
if (!global.gettext) {
    global.gettext = str => str;
}

// globals
require("./legacy/js/_banner").default;
require("./legacy/js/_buttons").default;
require("./legacy/js/clean_form").default;
require("./legacy/helpers/csrf_setup").default();
require("./legacy/js/_engage").default;
require("./legacy/js/handlebar_helpers").default;
require("./legacy/js/_image-error").default;
require("./legacy/js/_logout").default;
require("./legacy/helpers/jQserializeObject").default;
require("./legacy/js/logout_link").default;
require("./legacy/js/_tabs").default;
require("./legacy/js/topsites_preview").default;
require("./legacy/js/welcome_modal").default;

var components = {
    // new jsx files that use Redux!
    autodownloadmacapp: require("./components/auto-download-mac-app"),
    fort: require("./containers/fort"),
    nounproject: require("./containers/nounproject"),
    nounproject_footer: require("./components/nounproject-footer"),
    nounproject_navigation: require("./containers/nounproject-navigation-parent"),
    moderation: require("./containers/moderation"),
    plugin: require("./containers/plugin"),

    // legacy jsx files ported over from cjsx
    authmodal: require("./legacy/components/authmodal").default,
    collectionlist: require("./legacy/components/collectionlist_parent")
        .default,
    downloadmodal: require("./legacy/components/downloadmodal").default,
    footer: require("./legacy/components/footer").default,
    hero: require("./legacy/components/hero"),
    iconlist: require("./legacy/components/iconlist_parent").default,
    nav: require("./legacy/components/nav").default,
    searchbar: require("./legacy/components/searchbar").default,
    sharemodal: require("./legacy/components/sharemodal").default,

    // non jsx code that was ported over from coffeescript
    about: require("./legacy/js/about").default,
    accounts: require("./legacy/js/accounts").default,
    account_billing: require("./legacy/js/account_billing").default,
    admin: require("./legacy/js/admin").default,
    api_usage: require("./legacy/js/api_usage").default,
    app_video: require("./legacy/js/app_video").default,
    avatar: require("./legacy/js/avatar").default,
    billing: require("./legacy/js/billing").default,
    buttons: require("./legacy/js/_buttons").default,
    collection: require("./legacy/js/collection").default,
    creators: require("./legacy/js/creators").default,
    developers: require("./legacy/js/developers").default,
    handbook: require("./legacy/js/handbook").default,
    kits: require("./legacy/js/kits").default,
    kit_scroll: require("./legacy/js/kit_scroll").default,
    legal_tab: require("./legacy/js/legal_tab").default,
    notifications: require("./legacy/js/notifications").default,
    pricing: require("./legacy/js/pricing").default,
    pricing_signup: require("./legacy/js/pricing_signup").default,
    royalties: require("./legacy/js/royalties").default,
    section_nav: require("./legacy/js/section-nav").default,
    settings: require("./legacy/js/settings").default,
    team_page: require("./legacy/js/team_page").default,
    teams: require("./legacy/js/teams").default,
    upload: require("./legacy/js/upload").default
};

$(".react-es6-component").each(function() {
    var args, Component, componentName, comp, compInstance;
    componentName = $(this).data("componentName");
    Component = components[componentName];
    args = $(this).data("componentArgs");

    if (typeof args == "string") {
        try {
            args = JSON.parse(args);
        } catch (e) {
            console.warn("invalid json", args);
            args = [];
        }
    }

    var argProps = {};
    if (args) {
        args.forEach(arg => {
            for (var key in arg) {
                argProps[key] = arg[key];
            }
        });
    }

    // Landing module has no react component, so we shouldn't try to render it
    if (typeof Component == "function") {
        // note var Component must be capitalized otherwise jsx turns the variable name into a string

        // hack for hero. This will have to be here till we use routing for search pages
        if (componentName === "hero") {
            ReactDOM.render(<Component args={argProps} store={store} />, this);
        } else {
            ReactDOM.render(<Component args={argProps} />, this);
        }
    } else {
        if (Component && args) {
            //this function allows us to apply args without changing the component's scope
            var comp = function() {
                return Component.apply(this, args);
            };
            comp.prototype = Component.prototype;
            compInstance = new comp();
        } else if (Component) {
            compInstance = new Component();
        } else {
            console.warn("Component not found: " + componentName);
        }

        ReactDOM.render(<compInstance />, this);
    }
});

// for non-react components
$(".js-component").each(function() {
    var args, Component, componentName, comp, compInstance;
    componentName = $(this).data("componentName");
    Component = components[componentName];

    new Component();
});
